import ExceptionPage from "../../components/exception-page/ExceptionPage";

function NF400() {

    return (
        <ExceptionPage showHomebutton title={'400'} subTitle={'No Access'} description={'Authentication Error'}/>
    );
}

export default NF400;